import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/Card";
import { useGetAllEventQuery } from "@/services/EventApi";
import { format } from "date-fns";
import { CalendarDays } from "lucide-react";
import { Link, Navigate } from "react-router-dom";

const { VITE_ORG_ID } = import.meta.env;

export default function RedirectPage() {
    const {data: eventData, isLoading} = useGetAllEventQuery({
      org_id: VITE_ORG_ID,
    });
    const events = eventData?.data ?? [];

    if (isLoading) 
      return <div className="w-screen h-[calc(100vh-500px)] flex items-center justify-center">Redirecting...</div>;

    if (!events.length)
      return <Navigate to="/user/home" />;

    return (
        <section className="w-full h-full p-6 space-y-6">
          <h1 className="text-lg font-semibold">Where do you want to create a ticket?</h1>
          <div className="w-full h-full grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 items-stretch justify-center">
            {[...events, {event_id: "global", name: "Organization departments", description: "Access regular department dashboards for ticket registration", start_date: "", end_date: ""}].map(event => (
              <Link to={event.event_id === 'global' ? '/user/home' : `/user/home/${event.event_id}`}>
                <Card key={event.event_id} className="h-full min-h-40 border-l-4 border-l-primary min-h-40 min-w-40">
                    <CardHeader>
                      <CardTitle className="text-xl font-semibold">{event.name}</CardTitle>
                    </CardHeader>
                  <CardContent className="text-gray-600">
                    <p>{!!event.description && event.description}</p>
                    <p className="flex items-center gap-1 font-semibold">
                      {event.start_date && (<>
                        <CalendarDays className="h-4 w-4 text-gray-500 pb-[2px]" />
                        {`${format(new Date(event.start_date), "dd MMM yyyy")}` 
                        + (event.end_date ? `- ${format(new Date(event.end_date), "dd MMM yyyy")}` : '')}
                      </>)}
                    </p>
                  </CardContent>
                </Card>
              </Link>
            ))}
          </div>
        </section>
    );
}
